import find from 'lodash/find';
import editFullAttendanceTemplate from './../edit-full-attendance/edit-full-attendance.html';
import studentInfoTemplate from './../../dashboard/student-info/student-info.html';
import ChangesHistoryTemplate from './../../../components/changes-history/changes-history-dialog.html';
import template from './history-attendances.html';
import './history-attendances.scss';

class HistoryAttendancesComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, moment,
    StudentService,
    AttendanceService,
    CategoryOfDepartureService,
    ChangesHistoryService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.moment = moment;
    this.StudentService = StudentService;
    this.AttendanceService = AttendanceService;
    this.CategoryOfDepartureService = CategoryOfDepartureService;
    this.ChangesHistoryService = ChangesHistoryService;

    this.date = new Date();
  }

  $onChanges(changes) {
    if (changes.groups) {
      this.groups = Object.assign([], this.groups);
    }

    if (changes.historyAttendances) {
      this.historyAttendances = Object.assign([], this.historyAttendances);
    }
  }

  loadHistoryAttendances() {
    let groupId = this.selectedGroupId;
    if (groupId < 1) {
      groupId = null;
    }

    this.StudentService.getAttendances({
      day: this.moment(this.date).format('YYYY-MM-DD'),
      groupId,
      showLoaderSpinner: true
    }).then(result => {
      this.historyAttendances = result;
    })
      .catch(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Nie udało się pobrać frekwencji')
            .position('bottom right')
            .hideDelay(3000)
        );
      });
  }

  getAttendance(id) {
    return {...find(this.historyAttendances, item => item.id === id)};
  }

  showInfo(id, ev) {
    ev.stopPropagation();
    const attendance = this.getAttendance(id);
    this.StudentService.getInfo(attendance.student.id)
      .then(student => {
        this.$mdDialog.show({
          bindToController: true,
          controllerAs: 'ctrl',
          controller: 'StudentInfoController',
          locals: {student},
          template: studentInfoTemplate,
          disableParentScroll: true,
          clickOutsideToClose: true,
          targetEvent: ev
        });
      });
  }

  edit(id, ev) {
    const attendance = this.getAttendance(id);
    this.CategoryOfDepartureService.getAll().then(categoriesOfDeparture => {
      this.$mdDialog.show({
        bindToController: true,
        controllerAs: 'ctrl',
        controller: 'EditFullAttendanceController',
        locals: {attendance, categoriesOfDeparture},
        template: editFullAttendanceTemplate,
        disableParentScroll: true,
        clickOutsideToClose: true,
        targetEvent: ev
      })
        .then(() => {
          this.loadHistoryAttendances();
        });
    });
  }

  remove(id, ev) {
    const confirm = this.$mdDialog.confirm()
      .title('Czy na pewno chcesz usunąć frekwencję?')
      .textContent('Usuniętej frekwencji nie będzie można przywrócić.')
      .ariaLabel('Usunięcie frekwencji')
      .targetEvent(ev)
      .ok('Usuń')
      .cancel('Zamknij');

    this.$mdDialog.show(confirm).then(() => {
      this.AttendanceService.destroy([id])
        .then(() => {
          this.loadHistoryAttendances();
          this.$mdDialog.hide();
          this.$mdToast.show(
            this.$mdToast.simple()
              .textContent('Usunięto frekwencję')
              .position('bottom right')
              .hideDelay(3000)
          );
        })
        .catch(error => {
          this.$mdDialog.show(
            this.$mdDialog.extendError({
              locals: {error}
            })
          );
        });
    });
  }

  showChangesHistory(id, ev) {
    ev.stopPropagation();

    this.ChangesHistoryService
      .getAttendanceChanges(id)
      .then(changes => {
        this.$mdDialog.show({
          bindToController: true,
          controller: 'ChangesHistoryDialogController',
          controllerAs: 'ctrl',
          template: ChangesHistoryTemplate,
          locals: {
            changes,
            printAction: `/SCR/changesHistory/attendance/${id}?printPdf=true`
          },
          disableParentScroll: true,
          targetEvent: ev
        });
      });
  }
}

export const HistoryAttendances = {
  bindings: {
    historyAttendances: '<',
    groups: '<'
  },
  template,
  controller: HistoryAttendancesComponent
};
